import cloneDeep from 'lodash/cloneDeep';
import { getAll } from '@/api/devis/index';
import { pGetAllPieceJointe } from '@/api/pieceJointes';
import { PIECE_JOINTE_TYPE_LOGO } from '@/configuration/pieceJointeConf';
import transform from '@/services/general/transform';
import { transformToGescom } from '@/services/recommandation/recommandations';

export function construireQueryRecommandations({
  perPage,
  page,
  sortOrder,
  sortField,
  filtres,
  afficherRecomArchi,
  afficherRecomCommande,
}) {
  return {
    limit: perPage,
    page,
    ascending: sortOrder === 'asc',
    orderBy: sortField,
    query: {
      userId: filtres.userId || null,
      pointDeVente: filtres.pointDeVente || null,
      dateCreation: filtres.dateCreation || null,
      dateModif: filtres.dateModif || null,
      montant: filtres.montant || null,
      archive: afficherRecomArchi,
      devisNum: filtres.devisNum || null,
      societeId: filtres.societeId || null,
      groupeIds: filtres.groupeIds || null,
      enseigneIds: filtres.enseigneIds || null,
      pointDeVenteIds: filtres.pointDeVenteIds || null,
      afficherRecomCommande,
    },
  };
}

export default async function rechercheRecommandations(data) {
  const payload = transformToGescom(cloneDeep(data));
  const response = (await getAll(transform(payload))).data.result;

  const intervenants = response.items.map(item => item.intervenants).flat();
  const tiersIds = [
    ...new Set([
      ...intervenants.map(i => i.tiersId),
      ...intervenants.filter(i => i.tiers && i.tiers.tiersParentId).map(i => i.tiers.tiersParentId),
    ].filter(Boolean)),
  ];

  const pieces = (await pGetAllPieceJointe({ elementsId: tiersIds, placeType: PIECE_JOINTE_TYPE_LOGO })).data.result.items;

  response.items.forEach(item => {
    item.intervenants.sort((a, b) => (b.payeur ? 1 : 0) - (a.payeur ? 1 : 0));
    item.intervenants.forEach(i => {
      let piece = pieces.find(p => p.elementId === i.tiersId);
      if (!piece && i.tiers && i.tiers.tiersParentId) {
        piece = pieces.find(p => p.elementId === i.tiers.tiersParentId);
      }
      i.urlLogo = piece ? piece.cheminMin : null;
    });
  });

  return { items: response.items, totalCount: response.totalCount };
}
